class FfTab extends HTMLElement {
  constructor () {
    super();
  }

  connectedCallback() {
    this.ffIsOpen = false;
    this.ffIsDinamic = false;

    this.ffQuestion = this.querySelector(".ff-tab-question");
    this.ffQuestionIconContainer = this.querySelector(".ff-icon-img-container");
    this.ffQuestionIcon = this.querySelector(".ff-icon-img");

    this.ffAnswer = this.querySelector(".ff-tab-answer");
    this.ffAnswerHeight = this.ffAnswer.scrollHeight + 50;

    this.ffIconContainer = this.querySelector(".ff-icon-img-container");
    this.ffOpenedTabIcon = this.dataset.ffOpenedTabIcon;
    this.ffClosedTabIcon = this.dataset.ffClosedTabIcon;
    this.ffIconContainer.innerHTML = this.ffClosedTabIcon;

    this.ffQuestion.addEventListener("click", () => {
      this.ffIsOpen = !this.ffIsOpen;
      if (this.ffIsOpen) {
        this.ffOpenTab();
      } else {
        this.ffCloseTab();
      }
    });
  }

  ffOpenTab() {
    if(this.ffIsDinamic) {
      this.ffAnswer = this.querySelector(".ff-tab-answer");
      this.ffAnswerHeight = this.ffAnswer.scrollHeight + 50;
      this.ffAnswer.style.height = this.ffAnswerHeight + "px";
    } else {
      this.ffAnswer.style.height = this.ffAnswerHeight + "px";
    }
    this.ffAnswer.classList.add('ff-tab-answer-open');
    this.ffIconContainer.innerHTML = this.ffOpenedTabIcon;
  }

  ffCloseTab() {
    this.ffAnswer.style.height = 0;
    this.ffAnswer.classList.remove('ff-tab-answer-open');
    this.ffIconContainer.innerHTML = this.ffClosedTabIcon;
  }
}

customElements.define('ff-tab', FfTab);